import discountCodeResponses from '../testing/mocks/discountCodes';
import util from 'util';
import customRequest from './customRequest';

/*
    returns object of following format

    {
        price: number,
        message: String (for display on purchase page)
        messageType: "error", "warning", or "success", "clear" (use 'clear' for no message)
    }

 */


// STATUS MESSAGES
const MIN_ERROR = "Your discount code is valid, but is only applicable to numbers of students above %d.";
const MAX_ERROR = "Your discount code is valid, but is only applicable to numbers of students up until %d.";
const SUCCESS = "Success! You're receiving %s off your purchase price.";
const INVALID_ERROR = "The entered discount code doesn't exist or has expired.";

async function getPriceData(students, trainings, certs, discountCode) {
    let response = {};

    let discountResponse
    let products = (await customRequest.get('/api/products')).data
    const STUDENT_COST = products['Reading Subscription']/100.0;
    const TRAINING_COST = products['Training']/100.0;
    const VERIFICATION_COST = products['Verification']/100.0;
    response.prices = {
        'students': STUDENT_COST,
        'training': TRAINING_COST,
        'verification': VERIFICATION_COST
    }
    if(discountCode){
        discountResponse = (await customRequest.post('/api/subscribe/discount-code',{
            'discount-code': discountCode
        })).data //todo: replace with ajax call (make API call a promise)
    }
    let total_ = 0;
    total_ += STUDENT_COST * students;
    total_ += TRAINING_COST * trainings
    total_ += VERIFICATION_COST * certs;

    if (discountResponse == null) {
        response.price = total_;
        response.message = "";
        response.messageType = "clear";
    } else if (!discountResponse.allowed) {
        response.price = total_;
        response.message = INVALID_ERROR;
        response.messageType = "error";
    } else if (students < discountResponse.minStudents) {
        response.price = total_;
        response.message = util.format(MIN_ERROR, discountResponse.minStudents);
        response.messageType = "error";
    } else if (discountResponse.type === "Percentage") {
        let newTotal = 0;
        if (students > discountResponse.maxStudents) {
            newTotal = total_ - (STUDENT_COST * (discountResponse.amount / 100) * discountResponse.maxStudents);
            response.message = util.format(MAX_ERROR, discountResponse.maxStudents);
            response.messageType = "warning";
        } else {
            newTotal = total_ - (STUDENT_COST * (discountResponse.amount / 100) * students);
            response.message = util.format(SUCCESS, discountResponse.amount + "%");
            response.messageType = "success";
        }
        response.price = newTotal
    } else {
        response.price = total_ - discountResponse.amount;
        response.message = util.format(SUCCESS, "$" + discountResponse.amount);
        response.messageType = "success";
    }

    return response;
}

export default getPriceData;
